"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const account_1 = require("../../account");
const wallet_btc_1 = __importStar(require("./wallet-btc"));
const getAccountNetworkInfo_1 = require("./getAccountNetworkInfo");
/**
 * Returns the maximum possible amount for transaction
 *
 * @param {Object} param - the account, parentAccount and transaction
 */
const estimateMaxSpendable = ({ account, parentAccount, transaction, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
    const walletAccount = (0, wallet_btc_1.getWalletAccount)(mainAccount);
    let feePerByte = transaction === null || transaction === void 0 ? void 0 : transaction.feePerByte;
    if (!feePerByte) {
        const networkInfo = yield (0, getAccountNetworkInfo_1.getAccountNetworkInfo)(mainAccount);
        feePerByte = networkInfo.feeItems.defaultFeePerByte;
    }
    const maxSpendable = yield wallet_btc_1.default.estimateAccountMaxSpendable(walletAccount, feePerByte.toNumber(), //!\ wallet-btc handles fees as JS number
    ((_a = transaction === null || transaction === void 0 ? void 0 : transaction.utxoStrategy) === null || _a === void 0 ? void 0 : _a.excludeUTXOs) || [], transaction ? [transaction.recipient] : [], transaction === null || transaction === void 0 ? void 0 : transaction.opReturnData);
    return maxSpendable.lt(0) ? new bignumber_js_1.BigNumber(0) : maxSpendable;
});
exports.default = estimateMaxSpendable;
//# sourceMappingURL=js-estimateMaxSpendable.js.map